'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { useNavigation } from '@/hooks/navigation/use-navigation.hook';
import Select, { SelectItem } from '@/components/ui/select/select.component';
import { getBlogThemesWithPost } from '@/services/blog/get-blog-themes-with-post.service';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface BlogSelectThemesProps {
  selectedTheme?: string;
}

export function BlogSelectThemes({ selectedTheme }: BlogSelectThemesProps) {
  const [themes, setThemes] = useState<SelectItem[]>([]);
  const router = useRouter();
  const { buildLink } = useNavigation();
  const analytics = getAnalyticsPlugin();

  const fetchThemes = async () => {
    const themes = await getBlogThemesWithPost();

    if (!themes) {
      return;
    }

    const themeItems = themes.data.map((theme) => ({ label: theme.name, value: theme.slug, id: theme.id.toString() }));

    const allThemes = [{ label: 'Mostrar todas as categorias', value: 'all', id: '0' }, ...themeItems];

    setThemes(allThemes);
  };

  useEffect(() => {
    fetchThemes();
  }, []);

  const handleThemeChange = (theme: SelectItem | null) => {
    analytics.track(AnalyticsEnum.VIEW_BLOG_CATEGORY, {
      tema: theme?.label || 'all',
    });

    const params = new URLSearchParams({});

    if (theme && theme.value && theme.value !== 'all') {
      params.set('theme', theme.value);
    } else {
      params.delete('theme');
    }

    router.push(
      buildLink({
        path: '/blog',
        query: Object.fromEntries(params.entries()) as Record<string, string>,
      }),
    );
  };

  const selectedThemeItem = selectedTheme ? themes.find((theme) => theme.value === selectedTheme) || null : null;

  return (
    <>
      <div className="w-full md:w-75">
        <Select
          items={themes}
          selectedItem={selectedThemeItem}
          onChange={handleThemeChange}
          placeholder="Mostrar todas as categorias"
          dataTestId={DataTestIdEnum.BLOG_THEME_SELECT}
        />
      </div>
    </>
  );
}
